import Component from 'vue-class-component';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import BaseComponent from '@/components/base/BaseComponent';
import {
  CREATE_FORM_ERRORS,
  CREATE_FORM_LOADING,
  FORM101_DATA,
  FORM101_META_DATA,
  OPEN_CHANGES_NOTIFICATION_MODAL,
  OPEN_CHOOSE_FORM_OFFICE_MODAL,
  REINIT_AUTHENTICATION_TOKEN,
  SET_CREATE_FORM_ERRORS,
  SET_FORM101_ID,
  SET_OPEN_CHANGES_NOTIFICATION_MODAL,
  SET_OPEN_CHOOSE_FORM_OFFICE_MODAL,
} from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { USER_DETAILS } from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';
import ChooseFormOfficeModal from '@/components/modals/ChooseFormOffice.modal.vue';
import ChangesNotification from '@/components/modals/ChangesNotification.modal.vue';
import { Form101MetaData } from '@/models/form/Form101MetaData.model';
import {
  GET_CHANGES_NOTIFICATION_FLAG,
  OPEN_POPUP_CHANGES_NOTIFICATION_FLAG,
} from '@/types/lobby.types';

@Component({
  components: {
    ChangesNotification,
    ChooseFormOfficeModal,
  },
})
export default class WelcomePanelComponent extends BaseComponent {

  @Action(REINIT_AUTHENTICATION_TOKEN, StoreNamespace.FORM) public reinitAuthenticationToken;
  @Action(GET_CHANGES_NOTIFICATION_FLAG, StoreNamespace.LOBBY) public getChangesNotificationFlag;

  @Mutation(SET_CREATE_FORM_ERRORS, StoreNamespace.FORM) public setCreateFormErrors;
  @Mutation(SET_FORM101_ID, StoreNamespace.FORM) public setForm101Id;
  @Mutation(SET_OPEN_CHOOSE_FORM_OFFICE_MODAL, StoreNamespace.FORM) public setOpenChooseFormOfficeModal;
  @Mutation(SET_OPEN_CHANGES_NOTIFICATION_MODAL, StoreNamespace.FORM) public setOpenChangesNotificationModal;

  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(CREATE_FORM_ERRORS, StoreNamespace.FORM) public createFormErrors!: string[];
  @Getter(OPEN_CHOOSE_FORM_OFFICE_MODAL, StoreNamespace.FORM) public openChooseFormOfficeModal!: boolean;
  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;
  @Getter(CREATE_FORM_LOADING, StoreNamespace.FORM) public createFormLoading!: boolean;
  @Getter(OPEN_CHANGES_NOTIFICATION_MODAL, StoreNamespace.FORM) public openChangesNotificationModal!: boolean;
  @Getter(FORM101_META_DATA, StoreNamespace.FORM) public form101MetaData!: Form101MetaData;
  @Getter(OPEN_POPUP_CHANGES_NOTIFICATION_FLAG, StoreNamespace.LOBBY) public openPopupChangesNotificationFlag!: boolean;

  private taxYears: number[] = [];
  private taxYearClicked?: number;
  private welcomeCssClass = 'welcome-panel-component';

  public mounted() {
    this.setCreateFormErrors([]);
    this.setForm101Id(null);
    this.taxYears = this.userDetails.allowTaxYearList;
    this.taxYearClicked = undefined;
    this.getChangesNotificationFlag();
    setTimeout(() => {
      document.body.classList.add(this.welcomeCssClass);
    }, 100);
  }

  public beforeDestroy() {
    document.body.classList.remove(this.welcomeCssClass);
  }

  public onFillFormClick(taxYear: number) {
    if (this.openPopupChangesNotificationFlag) {
      this.setOpenChangesNotificationModal(true);
    } else {
      this.taxYearClicked = taxYear;
      this.reinitAuthenticationToken(taxYear);
    }
  }

  public continueToFillForm(taxYear: number) {
    this.taxYearClicked = taxYear;
    this.reinitAuthenticationToken(taxYear);
  }

  public onFillNewFormClicked(): void {
    this.setOpenChooseFormOfficeModal(true);
  }

}
